import { createContext, FC } from 'react';
import { useSettingsContext } from 'src/core/settings/useSettings';

export const EditsProvider: FC = ({ children }) => {
  const { settings, setSetting } = useSettingsContext();
  //const userEdits = null;
  //const setUserEdits = ()=>{  };
  return (
    <EditsContext.Provider value={{ userEdits: settings, setUserEdits: setSetting, }}>{children}</EditsContext.Provider>
  );
};

export const EditsContext = createContext<IEditsContext>({});

export interface IEditsContext {
  userEdits?: any,
  setUserEdits?: (value: any, key?: string, nestedKey?: string) => void
}
